import React from 'react';
import { withRouter } from 'react-router-dom';
import { ApiDataContext } from 'contexts/ApiDataContext';
import { VendorFileArchiveContext } from 'contexts/VendorFileArchiveContext';
import { PermissionsContext } from 'contexts/PermissionsContext';
import { HeaderPlaceholder, UploadWrapper, Wrapper, ExampleDownload, DownloadLink } from './VendorData.styles';
import UploadVendorData from '../../components/UploadVendorData';
import FileListDownload from 'Data/components/FileListDownload';
import { UploadVendorStateContext } from 'contexts/UploadVendorStateContext';
import { ApLoaderDefault } from '@alixpartners/ui-components';
import { getNormalizationTemplate } from 'utils/apiRequests';

export class VendorData extends React.Component {
	render() {
		const {
			status,
			refetchVendor,
			fileArchive,
			fetchFileArchive,
			isVendorFilesFetching,
			isVendorStateFetching,
		} = this.props;

		const fileList = fileArchive;
		return (
			<Wrapper>
				<UploadWrapper>
					{isVendorStateFetching ? (
						<ApLoaderDefault />
					) : (
						<>
							<HeaderPlaceholder />
							<UploadVendorData
								status={status}
								refetchVendorState={refetchVendor}
								fetchFileArchive={fetchFileArchive}
							/>
						</>
					)}
				</UploadWrapper>
				<FileListDownload
					data={fileList}
					isVendorFilesFetching={isVendorFilesFetching}
					fetchFileArchive={fetchFileArchive}
				/>
				<ExampleDownload>
					<span>
						Please be sure you are uploading an Raw Data in CSV format. You can
						download an example of the expected format below.
					</span>
					<DownloadLink
						href={getNormalizationTemplate()}
						target="_blank"
						download="template.csv"
					>
						Download example
					</DownloadLink>
				</ExampleDownload>
			</Wrapper>
		);
	}
}

export default withRouter(props => (
	<PermissionsContext.Consumer>
		{({ permissions }) => (
			<ApiDataContext.Consumer>
				{({ clearApiCache }) => (
					<UploadVendorStateContext.Consumer>
						{({ vendorStatus, refetchVendor, isVendorStateFetching }) => (
							<VendorFileArchiveContext.Consumer>
								{({
									fileArchive,
									refetch: fetchFileArchive,
									isFetching: isVendorFilesFetching,
								}) => (
									<VendorData
										status={vendorStatus}
										refetchVendor={refetchVendor}
										fileArchive={fileArchive}
										fetchFileArchive={fetchFileArchive}
										isVendorFilesFetching={isVendorFilesFetching}
										isVendorStateFetching={isVendorStateFetching}
										clearApiCache={clearApiCache}
										permissions={permissions}
										{...props}
									/>
								)}
							</VendorFileArchiveContext.Consumer>
						)}
					</UploadVendorStateContext.Consumer>
				)}
			</ApiDataContext.Consumer>
		)}
	</PermissionsContext.Consumer>
));
